import { render, staticRenderFns } from "./PickAnswer.vue?vue&type=template&id=63e6ce9e&"
import script from "./PickAnswer.vue?vue&type=script&lang=js&"
export * from "./PickAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports